import React, { Fragment } from 'react';
import { getRateMessagesProperties } from 'Components/widgets/rate-messages/RateMessages.utils';
import { Text } from 'Components/frameworks/text/Text';
export const RateMessages = ({ rate }: { rate: string | null | undefined }) => {
  if (!rate) {
    return null;
  }

  const { rateContent, rateTitle } = getRateMessagesProperties(rate);
  return (
    <Fragment>
      <Text className="block text-12 font-bold" text={rateTitle} />
      <Text className="block font-sans text-10" text={rateContent} />
    </Fragment>
  );
};
